var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep4Pc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "step_3_PC_closed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.13686838e-13,175.17407 L1.13686838e-13,173.805522 L20.106,173.805 L20.106,131.722 L1.13686838e-13,131.722689 L1.13686838e-13,130.354142 L20.106,130.354 L20.106,44.819 L0,44.819928 L0,43.4513806 L20.106,43.451 L20.106,1.368 L0,1.36854742 L0,0 L42.9502762,0 L42.9502762,1.36854742 L22.843,1.368 L22.843,43.451 L42.9502762,43.4513806 L42.9502762,44.819928 L22.843,44.819 L22.843,86.902 L42.9502762,86.9027611 L42.9502762,88.2713085 L22.843,88.271 L22.843,130.354 L42.9502762,130.354142 L42.9502762,131.722689 L22.843,131.722 L22.843,173.805 L42.9502762,173.805522 L42.9502762,175.17407 L1.13686838e-13,175.17407 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 42.9502762,
    height: 175.17407,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.281768,175.17407 L0,175.17407 L0,173.805522 L23.917,173.805 L23.917,131.74 L0,131.740696 L0,130.372149 L23.917,130.372 L23.917,88.307 L0,88.3073229 L0,86.9387755 L23.917,86.938 L23.917,44.801 L0,44.8019208 L0,43.4333733 L23.917,43.433 L23.917,1.368 L0,1.36854742 L0,0 L25.281768,0 L25.281768,175.17407 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 25.281768,
    height: 175.17407,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888888",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PC_closed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "square",
    points: "16 225 16 1 240 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.75,50.25 L109.75,136.75 L83.25,136.75 L83.25,50.25 L109.75,50.25 Z",
    id: "Fill-1",
    stroke: "#000100",
    strokeWidth: 0.5,
    fill: "#E1D8C3",
    transform: "translate(96.500000, 93.500000) scale(-1, 1) translate(-96.500000, -93.500000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 1.000000)",
    stroke: "#000100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dynamic",
    transform: "translate(0.000000, 4.825930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.662161,0.288115246 L42.662161,174.885954 L0.288115246,174.885954 L0.288115246,0.288115246 L42.662161,0.288115246 Z",
    id: "Fill-10",
    strokeWidth: 0.576230492,
    fill: "#B6AE9A"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    mask: "url(#mask-2)",
    strokeDasharray: "3.457382953181273,0.8643457382953181",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Static",
    transform: "translate(42.662983, 4.825930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9797834,0.288115246 L24.9797834,174.885954 L0.288115246,174.885954 L0.288115246,0.288115246 L24.9797834,0.288115246 Z",
    id: "Fill-4",
    strokeWidth: 0.576230492,
    fill: "#B6AE9A"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    mask: "url(#mask-4)",
    strokeDasharray: "3.457382953181273,0.8643457382953181",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Track",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    x: 0.25,
    y: 0.25,
    width: 129.5,
    height: 4.32593037
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(67.852814, 137.852814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(60.000000, 60.000000) rotate(-45.000000) translate(-60.000000, -60.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,0 L72,107 L48,107 L0,0",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.25,
    fill: "url(#linearGradient-5)",
    strokeDasharray: "6,4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192236,0 C16.6780912,0 17.0780743,0.312297374 17.1893661,0.757464375 L17.8106339,3.24253563 C17.9219257,3.68770263 18.3219088,4 18.7807764,4 L23,4 C23.5522847,4 24,4.44771525 24,5 L24,17 C24,17.5522847 23.5522847,18 23,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,5 C0,4.44771525 0.44771525,4 1,4 L5.21922359,4 C5.67809124,4 6.07807434,3.68770263 6.18936609,3.24253563 L6.81063391,0.757464375 C6.92192566,0.312297374 7.32190876,0 7.78077641,0 L16.2192236,0 Z M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C14.7614237,6 17,8.23857625 17,11 C17,13.7614237 14.7614237,16 12,16 C9.23857625,16 7,13.7614237 7,11 C7,8.23857625 9.23857625,6 12,6 Z M12,7 C9.790861,7 8,8.790861 8,11 C8,13.209139 9.790861,15 12,15 C14.209139,15 16,13.209139 16,11 C16,8.790861 14.209139,7 12,7 Z",
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12.2761424,8.5 12.5,8.72385763 12.5,9 C12.5,9.27614237 12.2761424,9.5 12,9.5 C11.1715729,9.5 10.5,10.1715729 10.5,11 C10.5,11.2761424 10.2761424,11.5 10,11.5 C9.72385763,11.5 9.5,11.2761424 9.5,11 C9.5,9.61928813 10.6192881,8.5 12,8.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 18,
    y: 6,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 2,
    y: 2,
    width: 3,
    height: 1,
    rx: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(105.852814, 30.852814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(60.000000, 60.000000) rotate(-90.000000) translate(-60.000000, -60.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,0 L72,107 L48,107 L0,0",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.25,
    fill: "url(#linearGradient-5)",
    strokeDasharray: "6,4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192236,0 C16.6780912,0 17.0780743,0.312297374 17.1893661,0.757464375 L17.8106339,3.24253563 C17.9219257,3.68770263 18.3219088,4 18.7807764,4 L23,4 C23.5522847,4 24,4.44771525 24,5 L24,17 C24,17.5522847 23.5522847,18 23,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,5 C0,4.44771525 0.44771525,4 1,4 L5.21922359,4 C5.67809124,4 6.07807434,3.68770263 6.18936609,3.24253563 L6.81063391,0.757464375 C6.92192566,0.312297374 7.32190876,0 7.78077641,0 L16.2192236,0 Z M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C14.7614237,6 17,8.23857625 17,11 C17,13.7614237 14.7614237,16 12,16 C9.23857625,16 7,13.7614237 7,11 C7,8.23857625 9.23857625,6 12,6 Z M12,7 C9.790861,7 8,8.790861 8,11 C8,13.209139 9.790861,15 12,15 C14.209139,15 16,13.209139 16,11 C16,8.790861 14.209139,7 12,7 Z",
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12.2761424,8.5 12.5,8.72385763 12.5,9 C12.5,9.27614237 12.2761424,9.5 12,9.5 C11.1715729,9.5 10.5,10.1715729 10.5,11 C10.5,11.2761424 10.2761424,11.5 10,11.5 C9.72385763,11.5 9.5,11.2761424 9.5,11 C9.5,9.61928813 10.6192881,8.5 12,8.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 18,
    y: 6,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 2,
    y: 2,
    width: 3,
    height: 1,
    rx: 0.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4Pc);
export default __webpack_public_path__ + "static/media/step_4_PC.37473b863cff564502220bac81ff5ed6.svg";
export { ForwardRef as ReactComponent };